export default "__VITE_ASSET__234f6004__"